import { render, staticRenderFns } from "./customersTable.vue?vue&type=template&id=5dc1c52d&"
import script from "./customersTable.vue?vue&type=script&lang=ts&"
export * from "./customersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports